// import { motion } from "framer-motion";
import indepthlogo from "../Images/indepthlogo.png";
import custmizedlogo from "../Images/custmizedlogo.png";
import seamless from "../Images/seamless.png";
import contiuneslogo from "../Images/contiuneslogo.png";
import indepthdev from "../Images/indeptdev.png";
import customizeddev from "../Images/custimzeddev.png";
import seamlessdev from "../Images/seamlessdev.png";
import contiunesdev from "../Images/contiunesdev.png";

const services = [
  {
    id: 1,
    number: "01",
    title: "In-depth discussions",
    subtitle: "to identify business challenges and goals.",
    description:
      "We start with a conversation to understand your business, goals, and how we might work together. By identifying your challenges and opportunities, we tailor solutions that align with your vision. Our collaborative approach ensures transparency, efficiency, and innovation, helping you achieve sustainable growth and long-term success in the digital landscape.",
    iconBg: "#FF4FE4", // Pink
    iconImg: indepthlogo,
    headingColor: "text-[#FF4FE4]",
    subtitleColor: "text-[#FF4FE4] ",
    illustration: indepthdev,
  },
  {
    id: 2,
    number: "02",
    title: "Customized partnership proposalst",
    subtitle: "tailored to your business needs",
    description:
      "Based on our discussion, we'll create a tailored partnership proposal that outlines the benefits and terms. This proposal will detail collaboration opportunities, strategic advantages, and customized solutions to align with your goals. With transparency and flexibility, we ensure a mutually beneficial partnership that fosters growth, innovation, and long-term success for your business.",
    iconBg: "#FF927B", // Orange
    iconImg: custmizedlogo,
    headingColor: "text-orange-500",
    subtitleColor: "text-orange-300 ",
    illustration: customizeddev,
  },
  {
    id: 3,
    number: "03",
    title: "Seamless agreement process",
    subtitle: "ensures clear partnership terms",
    description:
      "Once we agree on terms, we'll formalize our partnership and begin the onboarding process. This ensures a smooth transition with clear roles, responsibilities, and expectations. Our structured approach streamlines integration, minimizes delays, and maximizes efficiency, setting the foundation for a successful, long-term collaboration focused on growth and innovation.",
    iconBg: "#B7E333", // Teal
    iconImg: seamless,
    headingColor: "text-green-400",
    subtitleColor: "text-teal-200 ",
    illustration: seamlessdev,
  },

  {
    id: 4,
    number: "04",
    title: "Continuous innovation keeps",
    subtitle: "your business ahead competitively.",
    description:
      "We'll work together to implement our partnership strategy and drive mutual growth. Through strategic planning, innovation, and seamless execution, we ensure sustainable success. Our collaborative approach fosters efficiency, scalability, and long-term value. With continuous support and optimization, we help your business expand, adapt, and thrive in a competitive landscape.",
    iconBg: "#CA55FC", // Teal
    iconImg: contiuneslogo,
    headingColor: "text-purple-400",
    subtitleColor: "text-[] ",
    illustration: contiunesdev,
  },
];

const ServiceCard = () => {
  return (
    <>
      {/*  */}
      {/* Sub Header */}
      {/* <div className="mt-20"></div>
      <br />
      <br /> */}
      <div className="w-full relative  justify-between">
        {/*  */}
        <div className="md:pl-15 p-5 md:pt-15">
          <button className="bg-[#432DD7]  font-[Nunito] w-[270px] h-[60px] rounded-full text-white">
            Partnership Process
          </button>
          <h2 className="text-[#62739E] font-[Nunito] text-[16px] p-2 max-w-[1200px] text-justify">
            We offer a comprehensive range of IT services to help your business
            grow and succeed in the digital world. From custom software
            development and cloud solutions to cybersecurity and UI/UX design,
            our expert team ensures seamless digital transformation. Partner
            with us to enhance efficiency, drive innovation, and stay ahead of
            the competition.
          </h2>
        </div>

        <ul className="">
          {services?.map((items) => (
            <li key={items.id} className="sticky top-0 p-20 md:ml-15">
              <div className="w-full bg-white mt-10 flex-col md:flex-row flex">
                <div className="w-[2px] md:h-[100vh] h-[80vh] mt-15 bg-black absolute left-10 top-0">
                  <div className="w-4 h-4 rounded-full right-[7px] relative bg-black"></div>
                </div>
                <div className="w-full  items-center">
                  <h2 className="text-white font-[Nunito]">{items.number}</h2>
                  <img
                    src={items.iconImg}
                    alt=""
                    className="md:w-30 md:h-30 w-10 h-10"
                  />
                  <h2
                    className="md:text-[40px] text-[20px] font-[700]"
                    style={{ color: items.iconBg, fontFamily: "PT Sans" }}
                  >
                    {items.title}
                  </h2>
                  <h1 className="text-black md:text-[40px] text-[20px] font-[400] font-[Allison]">
                    {items.subtitle}
                  </h1>
                  <h2 className="text-black font-[Nunito] text-[8px] md:text-[16px] text-justify">
                    {items.description}
                  </h2>
                </div>
                <div className="w-full relative">
                  <img src={items.illustration} alt="" className="xl:ml-30" />
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default ServiceCard;

// const ServicesSection = () => {
//   return (
//     <section className="w-full bg-[#0D0D2B] py-12 px-4 sm:py-14 md:py-16 sm:px-6 md:px-8">
//       <motion.div
//         className="text-justify max-w-md sm:max-w-lg md:max-w-2xl lg:max-w-4xl mx-auto ml-10"
//         initial={{ opacity: 0, x: -50 }}
//         animate={{ opacity: 1, x: 0 }}
//         transition={{ duration: 1.5 }}
//       >
//         <motion.div
//           className="inline-block bg-[#432DD7] text-white px-5 py-2 sm:px-6 sm:py-3 md:px-7 md:py-3 rounded-full text-sm sm:text-base font-semibold mb-3"
//           initial={{ opacity: 0, x: -20 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 1.2 }}
//         >
//           Our Services
//         </motion.div>
//         <p className="text-white mt-4 leading-relaxed text-base sm:text-lg md:text-xl">
//           We offer a comprehensive range of IT services to help your business
//           grow and succeed in the digital world. From custom software
//           development and cloud solutions to cybersecurity and UI/UX design, our
//           expert team ensures seamless digital transformation. Partner with us
//           to enhance efficiency, drive innovation, and stay ahead of the
//           competition.
//         </p>
//       </motion.div>

//       {/* Call ServiceCard ONLY ONCE */}
//       <ServiceCard />
//     </section>
//   );
// };
